<template>
  <span>
    <master-sidebar v-if="showMaster" />
    <admin-sidebar v-else-if="showAdmin" />
    <client-sidebar v-else-if="showBioreq" />
  </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import adminSidebar from './admin'
import masterSidebar from './master'
import clientSidebar from './client'

export default {
  components: {
    adminSidebar,
    masterSidebar,
    clientSidebar
  },
  computed : {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    showMaster () {
      return this.role === 'owner' || this.role === 'master'
    },
    showAdmin () {
      return this.role === 'admin'
    },
    showBioreq () {
      return this.organization.enable_bioreq === 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue